import React from 'react';
import 'css/pikaday.css';
import moment from 'moment';
import { Button } from 'elements';
import { Close } from 'core/icons';
import tulkojumi from 'utils/tulkojumi';
import { dateFormatShort } from 'utils/momentDate';
import { TextInput } from '../';
import i18n from './i18n';
import {
  StyledWrapper,
  StyledContainer,
  CloseButtonWrapper,
} from './styled';

class DateInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dateSelected: props.date ? true : false,
    };
    this._today = moment().format(dateFormatShort);
  }

  _initPicker = () => {
    if (!this._pikaday) {
      this._pikaday = new Pikaday({
        field: this._input,
        container: this._container,
        format: dateFormatShort,
        firstDay: 1,
        i18n: i18n(this.props.teksti),
        onSelect: this._onSelect,
      });
    }
  }

  _onSelect = (date) => {
    if (this._preventSelectCallback) {
      this._preventSelectCallback = false;
      return false;
    }
    const { id, onChange } = this.props;
    onChange && onChange(id, moment(date).format('X'));
    // NOTE: Neliekam state šeit, jo nevajadzētu atjaunot state komponentam,
    // kas ir willUnmount ciklā, jo lapa tiks pārrenderēta pēc GraphQL refetch.
    /* this.setState(prevState => Object.assign({}, prevState, {
      dateSelected: true,
    })); */
  }

  _onClear = () => {
    const { id, onChange } = this.props;
    this.setState(prevState => Object.assign({}, prevState, {
      dateSelected: false,
    }), () => {
      // NOTE: Lai atsauktu dubultu atjaunošanu,
      // atsaucam callback pēc pikaday.setDate
      this._preventSelectCallback = true;
      if (this._pikaday) {
        this._pikaday.setDate(this._today);
      }
      this._input.value = '';
      onChange && onChange(id, null);
    });
  }

  _onInputChange = (event) => {
    const empty = event.target.value.length === 0;
    if (empty === this.state.dateSelected) {
      this._onClear();
    }
  }

  render () {
    const {
      id,
      placeholder,
      date,
      teksti,
      onClick,
    } = this.props;

    return (
      <StyledWrapper>
        <TextInput
          placeholder={`${placeholder}: ${this._today}`}
          defaultValue={date ? moment(date * 1000).format(dateFormatShort) : ''}
          innerRef={c => this._input = c}
          onClick={() => {
            if (!window.Pikaday) {
              import('pikaday')
              .then(pikaModule => {
                window.Pikaday = pikaModule;
                this._initPicker();
                this._pikaday.show();
              });
            } else if (!this._pikaday) {
              this._initPicker();
              this._pikaday.show();
            }
          }}
          onChange={this._onInputChange}
        />

        <CloseButtonWrapper>
          {
            this.state.dateSelected && (
              <Button
                type='text'
                accent='secondary'
                a11yLabel={tulkojumi(teksti, 'dzest')}
                icon={Close}
                onClick={() => {
                  this._onClear();
                }}
              />
            )
          }
        </CloseButtonWrapper>

        <StyledContainer
          innerRef={c => this._container = c}
        />
      </StyledWrapper>
    )
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/DateInput/DateInput.jsx